/**
 * useBodyScrollLock — verrou PARTAGÉ du scroll de la page (compteur).
 *
 * Quand une modale maison (Teleport) est ouverte, la page derrière ne doit
 * JAMAIS scroller (règle Karim 2026-08-05). Un simple `body.overflow=hidden`
 * par composant se fait écraser quand deux modales s'empilent (ex : article
 * d'actualité ouvert PAR-DESSUS « Toutes les actualités » : fermer l'article
 * déverrouillait la page alors que la liste était encore ouverte). Ici :
 * compteur global — le scroll ne revient que quand TOUTES les modales sont
 * fermées. À compléter côté CSS par `overscroll-behavior: contain` sur la
 * zone scrollable de chaque modale (anti-chaînage molette/tactile).
 */
export function useBodyScrollLock() {
  const lockCount = useState<number>("body-scroll-lock-count", () => 0);

  function apply() {
    if (import.meta.client) {
      document.body.style.overflow = lockCount.value > 0 ? "hidden" : "";
    }
  }

  function lock() {
    lockCount.value++;
    apply();
  }

  function unlock() {
    lockCount.value = Math.max(0, lockCount.value - 1);
    apply();
  }

  /**
   * Branche le verrou sur une source réactive « ouvert/fermé » + release
   * garanti au démontage du composant appelant.
   */
  function bindToRef(isOpen: () => unknown) {
    let held = false;
    watch(
      isOpen,
      (open) => {
        const shouldHold = Boolean(open);
        if (shouldHold && !held) {
          held = true;
          lock();
        } else if (!shouldHold && held) {
          held = false;
          unlock();
        }
      },
      { immediate: true },
    );
    onBeforeUnmount(() => {
      if (held) {
        held = false;
        unlock();
      }
    });
  }

  return { lock, unlock, bindToRef };
}
